import { CustomOrderNum } from "types/customOrderNum"
import { create } from "zustand"

export const useCustomerOrderNum = create<CustomOrderNum>((set) => ({
  orderNum: "",
  customOrderChange: (customOrderNum: string) =>
    set(() => ({ orderNum: customOrderNum })),
}))
